import connect from '../../core/EcrionProvider/connect';

function withManifest(WrappedComponent) {
  return connect(mapStateToProps, null, null, {
    pure: false
  })(WrappedComponent);
}

var mapStateToProps = function mapStateToProps(state) {
  return {
    manifest: state.manifest
  };
};

export default withManifest;